import React from 'react'
import Banner from "../../Components/Banner/ForgotPassword"
import Main from "../../Components/ForgotPassword/ForgotPassword"
import Scroll from "../../Components/ScrollToTop"

function ForgotPassword() {
  return (
    <div>
        <Scroll/>
        <Banner/>
        <Main/>
      
    </div>
  )
}

export default ForgotPassword
